var DepthCompareModeSoftware = (function () {
    function DepthCompareModeSoftware() {
    }
    DepthCompareModeSoftware.always = function (fragDepth, currentDepth) {
        return true;
    };
    DepthCompareModeSoftware.equal = function (fragDepth, currentDepth) {
        return fragDepth == currentDepth;
    };
    DepthCompareModeSoftware.greater = function (fragDepth, currentDepth) {
        return fragDepth > currentDepth;
    };
    DepthCompareModeSoftware.greaterEqual = function (fragDepth, currentDepth) {
        return fragDepth >= currentDepth;
    };
    DepthCompareModeSoftware.less = function (fragDepth, currentDepth) {
        return fragDepth < currentDepth;
    };
    DepthCompareModeSoftware.lessEqual = function (fragDepth, currentDepth) {
        return fragDepth <= currentDepth;
    };
    DepthCompareModeSoftware.never = function (fragDepth, currentDepth) {
        return false;
    };
    DepthCompareModeSoftware.notEqual = function (fragDepth, currentDepth) {
        return fragDepth != currentDepth;
    };
    return DepthCompareModeSoftware;
}());
export { DepthCompareModeSoftware };



// WEBPACK FOOTER //
// ../dist/lib/software/DepthCompareModeSoftware.js